import { render, staticRenderFns } from "./SectionEditForm.vue?vue&type=template&id=0a2eec7a"
import script from "./SectionEditForm.vue?vue&type=script&lang=js"
export * from "./SectionEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports